import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Nav from "components/Nav";
import React, { useState } from "react";

const drawerWidth = 240;

export default function NavDrawer() {
  const [open, setOpen] = useState(false);

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  return (
    <Drawer
      onMouseEnter={handleDrawerOpen}
      onMouseLeave={handleDrawerClose}
      ModalProps={{ onClose: handleDrawerClose }}
      variant="permanent"
      open={open}
      sx={(theme) => ({
        "& .MuiDrawer-paper": {
          width: open ? drawerWidth : theme.spacing(7),
          overflowX: open ? undefined : "hidden",
        },
      })}
    >
      <Box
        sx={(theme) => ({
          ...theme.mixins.toolbar,
        })}
      />
      <Nav handleDrawerClose={handleDrawerClose} open={open} />
    </Drawer>
  );
}
